import { client, deserializeJSONString } from '@trello/graphql';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from '@trello/redux';

// eslint-disable-next-line no-restricted-imports
import { BoardResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
// eslint-disable-next-line no-restricted-imports
import { State } from 'app/gamma/src/modules/types';
import {
  LoadBoardDocument,
  LoadBoardQuery,
  LoadBoardQueryVariables,
} from './LoadBoardQuery.generated';

// Action types
export const LOAD_BOARD_REQUEST = Symbol('loaders/LOAD_BOARD_REQUEST');
export const LOAD_BOARD_SUCCESS = Symbol('loaders/LOAD_BOARD_SUCCESS');
export const LOAD_BOARD_ERROR = Symbol('loaders/LOAD_BOARD_ERROR');

export type LoadBoardRequestAction = Action<typeof LOAD_BOARD_REQUEST, string>;
export type LoadBoardSuccessAction = Action<
  typeof LOAD_BOARD_SUCCESS,
  BoardResponse
>;
export type LoadBoardErrorAction = Action<typeof LOAD_BOARD_ERROR, Error>;

// Action creators
const loadBoardRequest = actionCreator<LoadBoardRequestAction>(
  LOAD_BOARD_REQUEST,
);
export const loadBoardSuccess = actionCreator<LoadBoardSuccessAction>(
  LOAD_BOARD_SUCCESS,
);
const loadBoardError = actionCreator<LoadBoardErrorAction>(LOAD_BOARD_ERROR);

export const loadBoard = (boardIdentifier: string): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    dispatch(loadBoardRequest(boardIdentifier));
    const { data, error } = await client.query<
      LoadBoardQuery,
      LoadBoardQueryVariables
    >({
      query: LoadBoardDocument,
      variables: {
        id: boardIdentifier,
      },
      // eslint-disable-next-line @trello/disallow-fetch-policies
      fetchPolicy: 'network-only',
      context: {
        operationName: 'LoadBoard',
        document: LoadBoardDocument,
      },
    });
    if (error) {
      dispatch(loadBoardError(error));
    } else {
      const board = data.board;
      if (!board) {
        return;
      }
      const dataToDispatch = {
        ...board,
        actions: board.actions.map((action) => ({
          ...action,
          data: deserializeJSONString(action.data),
          display: {
            ...action.display,
            entities: deserializeJSONString(action.display.entities),
          },
          limits:
            action.type === 'commentCard'
              ? { reactions: board.limits.reactions }
              : {},
        })),
      };
      // TODO: Subscribe to the board socket updates

      dispatch(loadBoardSuccess(dataToDispatch));
    }
  };
};
